import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ExamplesLandingComponent } from './examples-landing/examples-landing.component';
import { BarLineChartsComponent } from './examples/bar-line-charts/bar-line-charts.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ExamplesLandingComponent,
    BarLineChartsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
